import req from './http.js'

// 取得組織底下所有成員(包含店長、管理員、成員)
export const apiGetStaff = (org_id) => req('get', '/organization/getUser?org=' + org_id)

// 取得單一成員資訊
export const apiGetStaffInfo = (user_id, org_id) => req('get', '/organization/getUser/by?user_id=' + user_id + '&org=' + org_id)

// 新增組織成員
export const apiCreateStaff = (param, org_id) => req('post', '/organization/addUser?org=' + org_id, param)

// 取得該成員的所有權限
export const apiGetAuths = (org_id) => req('get', '/organization/auths?org=' + org_id)

// 更新該成員的權限
export const apiUpdateAuth = (org_id, param) => req('put', '/organization/auth?org=' + org_id, param)

// 取得會員訂閱資訊
export const apiGetSubscriptionInfo = (org_id) => req('get', '/organization/subscription?org=' + org_id)

export const apiGetSubscriptionInfoWithData = (org_id, start_at, end_at) => req('get', `/organization/subscription?org=${org_id}&start=${start_at ? start_at : ''}&end=${end_at ? end_at : ''}`).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

// 移除組織下指定使用者
export const apiDeleteStaff = (org_id, param) => req('delete', '/organization/removeUserFromOrg?org=' + org_id, param)

// 更新user的權限 是 一般使用者 還是 管理員
export const apiUpdateStaffRole = (org_id, param) => req('put', '/organization/changeUserRole?org=' + org_id, param)


// 取得組織資訊
export const apiGetOrganizeInfo = (
    org_id
) => req(
    'get',
    `/organization/info?org=${org_id}`
).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

// 更新組織名稱
export const apiRenameOrganization = (
    org_id,params
) => req(
    'post',
    `/organization/rename?org=${org_id}`,
    params
).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

// 查詢組織特定權限狀態
export const apiGetOrganizeFunctionStatus = (
    org_id, params
) => req(
    'get',
    `/organization/sub/function?org=${org_id}`,
    params
).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})


// 取得使用者資訊
export const apiGetUserInfo = (
    org_id,params
) => req(
    'post',
    `/organization/getUser/in?org=${org_id}`,
    params
).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})



